import { toast } from "react-toastify";
import html2canvas from "html2canvas";

export default async function printInvoices(elementId) {
  const baseUrl = process.env.REACT_APP_BASE_API_URL;

  if (!baseUrl) {
    toast.error("Printer not configured");
    return false;
  }

  const PRINT_URL = `${baseUrl}/images/upload`;
  const isKOT = elementId === "kot-print-section";

  try {
    const original = document.getElementById(elementId);
    if (!original) {
      toast.error(`Element "${elementId}" not found`);
      return false;
    }

    // Clone element for clean capture
    const clone = original.cloneNode(true);
    const style = document.createElement("style");

    style.innerHTML = isKOT
      ? `
        #kot-print-section {
          width: 100%;
          font-size: 125%;
          padding: 10px;
          background: white;
        }
        #kot-print-section * {
          margin: 0;
          padding: 2px 0;
          box-shadow: none;
          box-sizing: border-box;
        }
      `
      : `
        #invoice {
          font-size: 100%;
          padding: 15px;
          background: white;
        }
        #invoice * {
          margin: 0;
          padding: 2px 0;
          box-shadow: none;
        }
      `;

    clone.prepend(style);
    clone.style.position = "absolute";
    clone.style.left = "0";
    clone.style.top = "0";
    clone.style.background = "white";

    document.body.appendChild(clone);
    await new Promise((r) => requestAnimationFrame(r));

    // Render canvas
    const canvas = await html2canvas(clone, {
      backgroundColor: "#ffffff",
      useCORS: true,
      windowWidth: 300,
      windowHeight: clone.scrollHeight,
      logging: false,
    });

    document.body.removeChild(clone);

    // Convert canvas → JPEG FILE
    const blob = await new Promise((resolve, reject) => {
      canvas.toBlob(
        (b) => (b ? resolve(b) : reject("Failed to create image")),
        "image/jpeg",
        0.9
      );
    });

    const formData = new FormData();
    formData.append("image", blob, isKOT ? "kot.jpg" : "invoice.jpg");

    //  Send to API
    const response = await fetch(PRINT_URL, {
      method: "POST",
      body: formData,
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    // Expecting JSON: { token: "..." }
    const data = await response.json();
    const token = data?.token;

    if (!token) {
      throw new Error("Token not received from printer service");
    }

    toast.success(`🖨️ ${isKOT ? "KOT" : "Invoice"} sent to printer`);

    // Open app with token
    setTimeout(() => {
      window.location.href = `printerhelper://open?token=${encodeURIComponent(token)}`;
    }, 300);

    return true;

  } catch (err) {
    console.error("Print error:", err);
    toast.error("Print failed");
    return false;
  }
}
